import React, { FC } from 'react';
import { useLandingPageContext } from 'context/LandingPageContext';

export interface LPSeparatorProps {
  paddingBottom: number;
  paddingTop: number;
  paddingBottomMobile: number;
  paddingTopMobile: number;
}

const LPSeparator: FC<LPSeparatorProps> = ({ paddingBottom, paddingBottomMobile, paddingTop, paddingTopMobile }) => {
  const { isDesktopDevice } = useLandingPageContext();
  return isDesktopDevice ? (
    <div style={{ paddingBottom, paddingTop }} />
  ) : (
    <div style={{ paddingBottom: paddingBottomMobile, paddingTop: paddingTopMobile }} />
  );
};

export default LPSeparator;
